import Pr from "./Pr";
export default Pr;
